import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { req_list_ssp_stutents_now_detail } from "../../api";

class StudentsNowInfoModal extends Component {
  state = {
    userLevel: "",
    loading: false,
    item: {},
    items: [],
  };

  static propTypes = {
    item: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_list_items();
    this.setState({ item: this.props.item });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { item } = this.props;
    const { PlanAcademicYear, HighSchoolCode } = item;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_list_ssp_stutents_now_detail(
      userCode,
      userLevel,
      PlanAcademicYear,
      HighSchoolCode,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items: items, loading: false });
    } else {
      const items = [];
      this.setState({ items: items, loading: false });
    }
  };
  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "入學年度",
        dataIndex: "EnrolledAcademicYear",
        width: 30,
        responsive: ["md"],
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeTwName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "部別",
        dataIndex: "DivisionTwName",
        width: 40,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeTwName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeTwName",
        width: 40,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeTwName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學制",
        dataIndex: "EducationalSystemTwName",
        width: 40,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeTwName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "DepartmentTwName",
        width: 40,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeTwName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學號",
        dataIndex: "StudentId",
        width: 20,
        responsive: ["md"],
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeTwName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "姓名",
        dataIndex: "TwName",
        width: 20,
        responsive: ["md"],
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeTwName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items } = this.state;
    const { HighSchoolCode, HighSchoolTwName, CountyCity } = this.props.item;
    return (
      <Card>
        <form>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>所在縣市</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="CountyCity"
                  id="CountyCity"
                  defaultValue={CountyCity}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>學校代號</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="HighSchoolCode"
                  id="HighSchoolCode"
                  defaultValue={HighSchoolCode}
                  readOnly={true}
                />
                <div></div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>學校名稱</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="HighSchoolCode"
                  id="HighSchoolCode"
                  style={{ backgroundColor: "LightYellow" }}
                  defaultValue={HighSchoolTwName}
                  readOnly={true}
                />
              </div>
            </div>
          </div>
        </form>
        <Table
          key={items[0]}
          dataSource={items}
          columns={this.columns}
          loading={loading}
          scroll={{ y: 460 }}
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentsNowInfoModal);
